import i18n from "@/i18n";
export function getBirthday(date: string | Date): string {
  const dateFormation = new Date(date);
  const day =
    dateFormation.getDate() < 10
      ? `0${dateFormation.getDate()}`
      : dateFormation.getDate();
  const month =
    dateFormation.getMonth() + 1 < 10
      ? `0${dateFormation.getMonth() + 1}`
      : dateFormation.getMonth() + 1;
  const year = dateFormation.getFullYear();
  const result = `${day}.${month}.${year}`;
  return String(String(dateFormation) != "Invalid Date" ? result : "NaN");
}

export function getTimeAgo(date: string | Date): string {
  const today = new Date();
  const birthDate = new Date(date);
  if (String(birthDate) == "Invalid Date") return "Invalid Date";
  const delta: Date = new Date(today.getTime() - birthDate.getTime());

  const year = delta.getFullYear() - 1970;
  const month = delta.getMonth();
  const day = delta.getDate() - 1;
  const hours = delta.getHours();
  const minutes = delta.getMinutes();

  if (year > 0) {
    return `${year} ${
      year == 1
        ? i18n.t("Date.short.year1")
        : year > 4
        ? i18n.t("Date.short.year5")
        : i18n.t("Date.short.year24")
    }`;
  }

  if (month > 0 && month < 12) {
    return `${month} ${
      month == 1
        ? i18n.t("Date.short.month1")
        : month > 4
        ? i18n.t("Date.short.month5")
        : i18n.t("Date.short.month24")
    }`;
  }

  if (month > 0 && month < 12) {
    return `${month} ${
      month == 1
        ? i18n.t("Date.short.month1")
        : month > 4
        ? i18n.t("Date.short.month5")
        : i18n.t("Date.short.month24")
    }`;
  }
  if (day > 0 && day < 31) {
    return `${day} ${
      day == 1
        ? i18n.t("Date.short.day1")
        : day > 4
        ? i18n.t("Date.short.day5")
        : i18n.t("Date.short.day24")
    }`;
  }

  if (hours > 0 && hours < 24) {
    return `${hours} ${
      hours == 1
        ? i18n.t("Date.short.hours1")
        : hours > 4
        ? i18n.t("Date.short.hours5")
        : i18n.t("Date.short.hours24")
    }`;
  }

  if (minutes > 0 && minutes < 60) {
    return `${minutes < 1 ? 1 : minutes} ${
      minutes == 1
        ? i18n.t("Date.short.minutes1")
        : minutes > 4
        ? i18n.t("Date.short.minutes5")
        : i18n.t("Date.short.minutes24")
    }`;
  }
  console.log(birthDate);

  return String(birthDate) != "Invalid Date" ? "Zzz.." : "NaN";
}
